import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
export default function EditButton(props: any) {
  const navigate = useNavigate();
  return (
    <IconButton
      color="primary"
      size="small"
      onClick={() => navigate(props.navigateTo)}
    >
      <EditIcon />
    </IconButton>
  );
}
